export default __webpack_public_path__ + "static/media/Headphone.04a32fc1.svg";